import { TakeawayServices } from './../../../takeaway/services';
import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { OrdersServices } from '../../../kitchen/services';
import { OrdersCoServices } from '../../../orders/services';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { HttpClient } from '@angular/common/http';
import { CustomersCreateInfoPage } from '../../../customers/customers-create/customers-create-info/customers-create-info';


/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-print-ticket-or-eticket',
  templateUrl: 'print-ticket-or-eticket.html',
})
export class PrintTicketOrETicket {
  title: any;
  customer: any;
  table: any;
  is_email: boolean = false;
  is_customer: boolean = false;



  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public ordersServices: OrdersServices,
    public ordersCoServices: OrdersCoServices,
    public http: HttpClient,
    public translate: TranslateService,
    public afs: AngularFirestore,
    public takeawayServices: TakeawayServices,
    private toastCtrl: ToastController,
  ) {
    this.title = this.navParams.get('title');
    this.customer = this.navParams.get('customer');
    this.table = this.navParams.get('table');
    if (this.customer && this.customer != undefined) {
      if (this.customer.email != "") {
        this.is_email = true;
      }
      if (this.customer.name != undefined) {
        this.is_customer = true;
      }

    }
  }


  ionViewWillEnter() {

  }



  close() {
    this.viewCtrl.dismiss();
  }


  printTicket() {
    let data = 'printTicket'
    this.viewCtrl.dismiss(data);
  }

  eTicket() {
    let data = 'eTicket'
    this.viewCtrl.dismiss(data);
  } 
  editCustomer() {

    let data = 'editCustomer'
    this.viewCtrl.dismiss(data);
  }

  showInfoCustomer() {

    if (this.takeawayServices.customer.UID) {
      this.navCtrl.push(CustomersCreateInfoPage, {
        update_state: true,
        customer_uid: this.takeawayServices.customer.UID,
        name: this.takeawayServices.customer.name,
        business_name: this.takeawayServices.customer.business_name,
        business_number: this.takeawayServices.customer.business_number,
        email: this.takeawayServices.customer.email,
        phone: this.takeawayServices.customer.phone,
        address: this.takeawayServices.customer.address,
        note: this.takeawayServices.customer.note,
      });
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-no-hay-cliente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  eTicketActive() {
    this.takeawayServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tickets.ticket_digital': false,
    }).then(() => {
      this.globals.restaurant.tickets.ticket_digital = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/popups/print-ticket-or-eticket/print-ticket-or-eticket.ts